import {Component, OnInit} from '@angular/core';
import {DefaultModalService} from '@app/shared/modal/services/default-modal.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {ModalInstance} from '../types/default-modal.types';

@UntilDestroy()
@Component({
  selector: 'dcp-default-modal-container',
  templateUrl: './default-modal-container.component.html',
})
export class DefaultModalContainerComponent implements OnInit {
  modals: ModalInstance[] = [];

  constructor(private modalService: DefaultModalService) { 
  }
  
  ngOnInit(): void {
    this.modalService.getModals().pipe(untilDestroyed(this)).subscribe(modals => {
      this.modals = modals;
    });
  }
}
